module.exports = __webpack_public_path__ + "img/cross-icon-omni.8d1c6f51.png";